export const REPORT_REQUEST_PAYLOAD = Object.freeze({
    TIMEFRAME: 'timeFrame',
    MARKETPLACE: 'marketplace'
})


// WEBPACK FOOTER //
// ./src/constants/payload.js